<template>
  <div class="advertCostDetail">
    <div v-for="(item, i) in rowData" :key="i">
      <div class="common_readonly_template">
        <el-row>
          <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
            <div>
              <div class="label">{{ $t('newApp.Attribute.OrderNumber') }}</div>
              <div class="text">{{ item.prodCode }}</div>
            </div>
          </el-col>
          <el-col :xs="10" :sm="10" :md="10" :lg="10" :xl="10">
            <div>
              <div class="label">{{ $t('newApp.Attribute.TotalCcosts') }}</div>
              <div class="text">{{ item.odrAmount }}</div>
            </div>
          </el-col>
          <el-col :xs="2" :sm="2" :md="2" :lg="2" :xl="2">
            <div class="delete">
              <el-button class="delete-btn" type="button" @click="handleDeleteOnlyOrder(item)">删除</el-button>
            </div>
          </el-col>
        </el-row>
      </div>
      <el-table
        class="table-container"
        :header-cell-style="{
          background: '#F6F7F9',
          fontWeight: 'normal',
          color: '#5B646E'
        }"
        :data="item.productList"
        border
        style="width: 100%"
      >
        <el-table-column prop="productName" :label="$t('newApp.ADList.noa')" />
        <el-table-column prop="unitprice" :label="$t('newApp.ADList.up')" />
        <el-table-column prop="buynum" :label="$t('newApp.Attribute.nop')" />
        <el-table-column prop="osubAmount" :label="$t('newApp.Attribute.sp')" />
      </el-table>
    </div>
  </div>
</template>
<script>
import { newApplicationFormApi } from '../../service/index';
import { bus } from '@/utils/bus';
export default {
  data () {
    return {
      dialogVisible: false,
      formData: {}
    };
  },
  props: {
    rowData: {
      type: Array,
      default: () => []
    },
    activityCode: {
      type: String,
      default: ''
    }
  },
  methods: {
    handleDeleteOnlyOrder (item) {
      const params = {
        orderCode: item.prodCode,
        eventCode: this.activityCode
      };
      newApplicationFormApi.deleteOrderCode(params).then(res => {
        if (res.status === '200') {
          this.$message.success('删除成功');
          bus.$emit('deleteOrdeCodeSuccess', 'deleteSuccess');
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.advertCostDetail{
  width: 900px;
  max-height:500px;
  overflow: auto;
  background: #fff;
  z-index: 999;
  padding:20px;
}
.common_readonly_template {
  overflow: hidden;
  margin-bottom: 10px;
  .val > span {
    margin-left: 20px;
    color: #3384fe;
    cursor: pointer;
  }
}
.table-container {
  margin-bottom: 30px;
}
.delete{
  width: 100%;
  height: 100%;
}
.delete-btn{
  border: 0;
  height:55px;
  border-radius:0;
  border: none;
}
</style>
